module.exports = __webpack_public_path__ + "img/oracle.1ab3c7a1.png";